module.exports = __webpack_public_path__ + "ticket.svg?ca9edfa70af0ed826c7596d7f00b6c68";